<template>
    <div class="flex items-center justify-between">
        <div class="flex flex-col">
            <div class="mb-5">
                <t-input
                    v-model="billId"
                    placeholder="Bill Id"
                />
            </div>
            <div class="mb-5">
                <t-input
                    v-model="shippedPayload.driverName"
                    placeholder="Driver Name"
                />
                <t-input
                    v-model="shippedPayload.truckNumber"
                    placeholder="Truck Number"
                />
                <t-button
                    type="button"
                    variant="success"
                    @click="changeStatusToShipped()"
                >
                    Shipped
                </t-button>
            </div>
            <div>
                <t-input
                    v-model="deliveredPayload.paymentType"
                    placeholder="Payment Type"
                />
                <t-input
                    v-model="deliveredPayload.cashAmount"
                    placeholder="Cash Amount"
                />
                <t-input
                    v-model="deliveredPayload.checkAmount"
                    placeholder="Check Amount"
                />

                <div>
                    <div class="flex gap-5">
                        <div>
                            <t-input
                                v-model="deliveredPayload.checkPayments[0].bankId"
                                placeholder="Bank Id"
                            />
                        </div>
                        <div>
                            <t-input
                                v-model="deliveredPayload.checkPayments[0].checkNumber"
                                placeholder="Check Number"
                            />
                        </div>
                        <div>
                            <t-input
                                v-model="deliveredPayload.checkPayments[0].checkAmount"
                                placeholder="Check Amount"
                            />
                        </div>
                    </div>
                    <div class="flex gap-5">
                        <div>
                            <t-input
                                v-model="deliveredPayload.checkPayments[1].bankId"
                                placeholder="Bank Id"
                            />
                        </div>
                        <div>
                            <t-input
                                v-model="deliveredPayload.checkPayments[1].checkNumber"
                                placeholder="Check Number"
                            />
                        </div>
                        <div>
                            <t-input
                                v-model="deliveredPayload.checkPayments[1].checkAmount"
                                placeholder="Check Amount"
                            />
                        </div>
                    </div>
                </div>
                <t-button
                    type="button"
                    variant="success"
                    @click="changeStatusToDelivered()"
                >
                    Delivered
                </t-button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            billId: 3,

            shippedPayload: {
                driverName: 'test Name',
                truckNumber: '1234',
            },

            deliveredPayload: {
                paymentType: 'COD',
                cashAmount: '1000',
                checkAmount: '240.74',
                checkPayments: [
                    {
                        checkNumber: '0010',
                        checkAmount: '200',
                        bankId: '1',
                    },
                    {
                        checkNumber: '0020',
                        checkAmount: '40.74',
                        bankId: '1',
                    },
                ],
            },
        };
    },

    methods: {
        changeStatusToShipped() {
            axios.get(route('bill.shipped', this.billId), {
                headers: {
                    Accept: 'application/json',
                },
                params: this.shippedPayload,
            });
        },

        changeStatusToDelivered() {
            axios.get(route('bill.delivered', this.billId), {
                headers: {
                    Accept: 'application/json',
                },
                params: this.deliveredPayload,
            });
        },
    },
};
</script>
